import { render, staticRenderFns } from "./image-carousel.vue?vue&type=template&id=4e5b3268&"
import script from "./image-carousel.vue?vue&type=script&lang=js&"
export * from "./image-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e5b3268')) {
      api.createRecord('4e5b3268', component.options)
    } else {
      api.reload('4e5b3268', component.options)
    }
    module.hot.accept("./image-carousel.vue?vue&type=template&id=4e5b3268&", function () {
      api.rerender('4e5b3268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/finishes-detail/components/image-carousel.vue"
export default component.exports